"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import l from "../components/Icon/SvgIcon.js";
const t = (r) => /* @__PURE__ */ o(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.646 19.205a2 2 0 0 1-.744-.744L2.066 4.748A.5.5 0 0 1 2.5 4h18.277a.5.5 0 0 1 .434.748l-7.836 13.713a2 2 0 0 1-2.729.744m.992-1.736L18.192 6H5.085z",
        clipRule: "evenodd"
      }
    )
  }
), w = e(t);
export {
  w as ArrowDown,
  w as default
};
